import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { base_url } from '../context/Authcontext';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const defaultColors = {
    "--dark-theme-color": "#f0eeee",
    "--dark-theme-color-navbar": "#ffffff",
    "--dark-theme-data-color": "#023448",
    "--dark-theme-data-border": "#efeded",
    "--dark-theme-data-box": "#43ceed",
    "--dark-theme-data-homebet": "#052e36",

    "--dark-theme-data-homebet2": "#1d0520",
    "--dark-theme-data-backbtn": "#0A6E8A",
    "--dark-theme-data-set": "#064150",
    "--dark-theme-data-set2": "#36013c",
    "--dark-theme-data-min": "#166534",
    "--dark-theme-data-stake": "#7e22ce",
    "--dark-theme-data-clear": "#991b1b",
    "--dark-theme-data-cancel": "#ef4444",
    "--dark-theme-data-submit": "#22c55e",
    "--dark-theme-data-box2": "#f8bafd",
    "--dark-theme-data-box3": "#f9e0fc",
    "--dark-theme-sidebar-hovers": "#7fc5e0",
    "--dark-theme-data-bg": "#ffffff",
    "--dark-theme-card-bg-light": "#222c3b",
    "--dark-theme-card-bg-light-gradiant": "#19233c",
    "--dark-theme-card-bg-light2": "#01173b",
    "--dark-theme-white-color": "#000000",
    "--dark-theme-bg": "#022c43",
    "--dark-theme-demoaccount": "#ff0000",
    "--dark-theme-card-bg": "#5ecbdd",
    "--dark-theme-button-special": "#5ecbdd",
    "--dark-theme-dark-blue-variant": "#005762",
    "--dark-theme-dark-blue-bm": "#3454bf",
    "--dark-theme-time-remaining": "#42afdb",
    "--bg-btn": "#5ecbdd",
    "--text-color": "#ffffff",
    "--report-cate-item-border-clr": "#ffe500"
  };

  const [themeColors, setThemeColors] = useState(defaultColors);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const res = await axios.get(`${base_url}/get`);
        const themeData = res.data.theme || {};
        setThemeColors({ ...defaultColors, ...themeData });
      } catch (err) {
        console.error("Failed to fetch theme:", err);
      }
    };
    fetchTheme();
  }, []);


  // ⬇️ Apply theme to document CSS variables
  useEffect(() => {
    Object.entries(themeColors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  }, [themeColors]);

  return (
    <ThemeContext.Provider value={{ themeColors, setThemeColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
